import { Component, inject, input } from '@angular/core';
import { faClose } from '@fortawesome/pro-regular-svg-icons';

import { SurveyConditionalsService } from '../../../../services/survey-conditionals.service';

@Component({
  selector: 'empathy-selected-range-view',
  templateUrl: './selected-range-view.component.html',
  styleUrls: ['./selected-range-view.component.scss', '_selected-range-view-theme.component.scss']
})
export class SelectedRangeViewComponent {
  values = input<string[]>();

  faClose = faClose;

  surveyConditionalsService = inject(SurveyConditionalsService);
  onClearSelectedValues(): void {
    this.surveyConditionalsService.conditionForm$().get('valueToMatch').reset();
  }
}
